import React from "react"
import _ from "lodash"
import PropTypes from "prop-types"
import BasicBar from "../../components/BasicBar"
import { Link } from "react-router-dom"
import tippsGreetingImage from "../../assets/img/Tipps_Greeting.png"
import headerImage from "../../assets/img/banners/Explore_Plan_Cover.jpg"
import FilterContainer from "../../containers/FilterContainer/index"
import ImageHeader from "../../components/ImageHeader"
import HintButton from "../../components/HintButton"
import WorkProductRow from "./WorkProductRow"
//importing related to onboarding guide
import { OnboardingGuideBanner } from "../../components/OnboardingHomepage"
import { OnboardingTeacherContext } from "../../contexts/OnboardingTeacherContextProvider"

import "../../assets/css/pages/track_progress/track-progress-quest-page.css"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
library.add(faCircle)

const TrackProgressQuestPage = props => {
  const { isLoading, questName, workProductData } = props
  const { isAllComplete } = React.useContext(OnboardingTeacherContext)
  return (
    <div id='track-progress-quest-page'>
      <ImageHeader
        image={headerImage}
        titleContents='Track Progress'
        containerClass='modules-container'
      >
        <FilterContainer dateFilter={true} contentFilter={false} />
        <div className='page-content'>
          {!isAllComplete && <OnboardingGuideBanner />}
          <div className='breadcrumb-container'>
            <div className='breadcrumbs'>
              Assignment Progress &gt;&nbsp;
              {!questName && (
                <span className='loading-bar'>
                  <BasicBar />
                </span>
              )}
              {!!questName && questName}
            </div>
            <div className='back-link'>
              <Link to='/track_progress'>&lt;&lt; Return to Track Progress</Link>
            </div>
          </div>

          <h1>
            Quest:&nbsp;
            {!questName && (
              <span className='loading-bar'>
                <BasicBar />
              </span>
            )}
            {!!questName && questName}
          </h1>
          <div className='quality-legend'>
            <span className='status'>Status: </span>
            <span className='legend-item incomplete'>
              <FontAwesomeIcon icon='circle' /> = Not Completed
            </span>
            <span className='legend-item great-struggle'>
              <FontAwesomeIcon icon='circle' /> = Completed with a lot of struggle
            </span>
            <span className='legend-item struggle'>
              <FontAwesomeIcon icon='circle' /> = Completed with struggle
            </span>
            <span className='legend-item no-struggle'>
              <FontAwesomeIcon icon='circle' /> = Completed well
            </span>
            <span className='status-hint'>
              <HintButton hint='Status is defined specifically & uniquely for each work product based on the average number of tries it takes students to achieve the correct solution for a given work product.' />{" "}
              What is status?
            </span>
          </div>

          {!isLoading && (
            <div className='work-product-rows'>
              {workProductData.length > 0 &&
                _.map(workProductData, row => (
                  <WorkProductRow key={JSON.stringify(row)} {...row} />
                ))}
              {workProductData.length === 0 && (
                <div className='non-gradable-content'>
                  <img src={tippsGreetingImage} />
                  <div className='title'>Non-Gradable Content</div>
                  <div className='text'>
                    This quest built knowledge for your students, but did not ask them to do any
                    work product tasks that could generate valid assessment data. If it is part of a
                    Storyline, another quest will require them to produce work product data for
                    assessment.
                  </div>
                </div>
              )}
            </div>
          )}
          {isLoading &&
            _.map(new Array(workProductData.length || 2), (i, index) => (
              <div className='work-product-loading-rows' key={`loading-bar-${index}`}>
                <span className='loading-bar'>
                  <BasicBar />
                </span>
              </div>
            ))}
        </div>
      </ImageHeader>
    </div>
  )
}

const { string, bool, array, object, oneOfType, arrayOf } = PropTypes

TrackProgressQuestPage.propTypes = {
  questName: string,
  isLoading: bool.isRequired,
  workProductData: oneOfType([arrayOf(object), object]).isRequired
}

export default TrackProgressQuestPage
